package at.theatervogelweide.admin.web.screens

import androidx.compose.runtime.Composable
import at.theatervogelweide.admin.web.components.AdminButton
import at.theatervogelweide.admin.web.components.AdminCard
import at.theatervogelweide.admin.web.components.Bem
import at.theatervogelweide.admin.web.components.ButtonVariant
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

private val signIn = Bem("admin-sign-in")

/** Shown when the app can't find out whether someone is signed in, e.g. while the server restarts. */
@Composable
fun UnavailableScreen(onRetry: () -> Unit) {
    Div({ classes(signIn.block) }) {
        Div({ classes(signIn.element("panel").className) }) {
            AdminCard(
                title = "Verwaltung nicht erreichbar",
                id = "nicht-erreichbar",
                titleLevel = 1,
                footer = {
                    AdminButton(variant = ButtonVariant.PRIMARY, block = true, onClick = onRetry) { Text("Erneut versuchen") }
                },
            ) {
                P({ attr("role", "alert") }) {
                    Text("Der Server antwortet gerade nicht. Bitte versuche es in einem Moment noch einmal.")
                }
            }
        }
    }
}
